import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If there's a hash in the URL, don't scroll to top
    if (hash) {
      // Find the element with the hash ID
      const element = document.getElementById(hash.slice(1));
      if (element) {
        // Add a slight delay to ensure proper scroll after render
        setTimeout(() => {
          const headerOffset = 80; // Adjust based on your header height
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }, 100);
      }
      return;
    }

    // Otherwise, scroll to top with smooth animation
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [pathname, hash]); // Trigger on route change

  return null;
} 